<template>
	<v-form
		class="password-recovery-form"
		ref="form"
		v-model="valid"
		lazy-validation
		@submit.prevent="validateAndSubmit"
	>
		<v-row>
			<v-col cols="12" class="mb-2">
				<p class="password-recovery-form__description mb-0">Email</p>
				<v-text-field
					class="pt-0"
					color="red"
					v-model="fields.email"
					:error-messages="field_errors.email"
					:rules="rules.email"
					required
					placeholder="Enter your email"
				>
				</v-text-field>
			</v-col>
			<p v-for="error in errors" :key="error" class="text-danger">
				{{ error }}
			</p>
			<v-col cols="12" class="text-center mb-4">
				<v-btn
					class="align-center px-11 py-6 password-recovery-form__submit"
					type="submit"
					:loading="loading"
				>
					Restore
				</v-btn>
			</v-col>
		</v-row>
	</v-form>
</template>

<script>
import Form from '../../mixins/Form'
import { mapActions } from 'vuex'
import { ruleEmail, ruleRequired } from '@/utils/rules'

export default {
	name: 'PasswordRecoveryForm',
	mixins: [Form],
	data: () => ({
		fields: {
			email: '',
		},
		showPassword: false,
	}),
	computed: {
		rules() {
			return {
				email: [
					(v) => ruleRequired(v) || 'Field is required.',
					(v) => ruleEmail(v) || 'Please enter a valid email address.',
				],
			}
		},
	},
	methods: {
		...mapActions('auth', ['passwordRecovery']),
		submitForm() {
			const { email } = this.fields
			return this.passwordRecovery({ email })
		},
	},
}
</script>

<style scoped lang="scss">
.password-recovery-form {
	font-family: Montserrat, system-ui;

	.theme--light.v-input input {
		color: #000;
	}

	.v-text-field {
		input {
			padding: 10px 0 20px;
			font-size: 20px;
			font-weight: 500;
			max-height: 50px;
		}
	}

	.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
		color: #e5e5e5;
		border-color: #e5e5e5;
	}

	.password-field {
		.v-input__append-inner {
			margin-top: 0;
			.v-input__icon--append {
				.v-icon {
					color: #e5e5e5;
					padding: 30px 0 20px;
				}
			}
		}
	}

	input::placeholder {
		color: #e5e5e5 !important;
		opacity: 1;
	}

	&__description {
		font-weight: bold;
		font-size: 18px;
	}

	button[type='submit'] {
		border-radius: 54.5px;
		font-style: normal;
		font-weight: bold;
		font-size: 16px;
		text-transform: none;
		background-color: var(--accent-color) !important;
		color: #fff;
	}
}
</style>
